import React, { useState } from "react";
import "./aboutUsBanner.scss";
import CustomInput from "../../common/CustomInput";
 

const AboutUsBanner = ({ handleChange, data, errors }) => {
  const [previewImage, setPreviewImage] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewImage(reader.result);
        handleChange({ target: { name: "aboutus_image", value: file } });
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewImage(null);
      handleChange({ target: { name: "aboutus_image", value: null } });
    }
  };

  return (
    <div className="main_section_aboutUs">
      <p className="section_title">About Us Banner</p>
      <div className="titleAndDescription">
        <div className="width_50">
          <CustomInput
            label="Image"
            type="file"
            isCompulsory={true}
            accept="image/*"
            style={{
              padding: "13px",
            }}
            handleChange={handleImageChange}
            name="aboutus_image"
            error={errors.aboutus_image}
          />
          {previewImage && previewImage.startsWith("data:") ? (
            <img src={previewImage} alt="Preview" className="preview-image" />
          ) : data?.aboutus_image ? (
            <img
              src={data?.aboutus_image}
              alt="Preview"
              className="preview-image"
            />
          ) : null}
        </div>
        <div className="width_50">
          <CustomInput
            label="Description"
            isCompulsory={true}
            name="aboutus_description"
            handleChange={handleChange}
            value={data.aboutus_description}
            error={errors.aboutus_description}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutUsBanner;
